// MapManager.js
var MapManager = pc.createScript('mapManager');

MapManager.attributes.add('LevelImages', {type: 'entity', array: true});
MapManager.attributes.add('MapTextures', {type: 'asset', assetType: 'sprite', array: true});
 
MapManager.prototype.initialize = function() {
    MapManager.instance = this;
};

MapManager.prototype.InitializeMap = function () {

    let levelCount = PlayerManager.instance.getUserLevelByUserScore();

    for (var i = 0; i < levelCount; i++) {

        if ((levelCount - 1) === i) {

            this.LevelImages[i].element.spriteAsset = this.MapTextures[1];

            this.rankElement = this.LevelImages[i];

            this.anim = this.rankElement
                .tween(MapManager.instance.rankElement.getLocalScale())
                .to(new pc.Vec3(1.1, 1.1, 1.1), 1.0, pc.SineOut)
                .loop(true)
                .yoyo(true);

            this.anim.start();

            this.rankElement.children[2].findByName("scoreTxt").element.text = PlayerManager.instance.userData.userScore;
        }
        else {
            this.LevelImages[i].element.spriteAsset = this.MapTextures[0];
            this.LevelImages[i].children[2].enabled = true;
        }
    }
};

